import type { FunctionComponent, ReactNode } from 'react';

import IconCheck from 'assets/images/icon-check-in-cloud-20px.svg';

import './style.scss';

type PropsT = {
  children: ReactNode;
  title: string;
};

const Item: FunctionComponent<PropsT> = ({
  children,
  title,
}) => (
  <div styleName="container">
    <IconCheck />
    <div>
      <div styleName="title">{title}</div>
      <div>{children}</div>
    </div>
  </div>
);

export default Item;
